import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VApp,
    { class: { "filters-loading": _setup.filtersStore.isLoading } },
    [
      _c(_setup.ChipsFilters),
      _vm._v(" "),
      _c(_setup.PlaceFilters),
      _vm._v(" "),
      _c(_setup.LpuTypeFilters),
      _vm._v(" "),
      _c(_setup.TimeWorkFilters),
      _vm._v(" "),
      _c(_setup.DoctorSpecialityFilters),
      _vm._v(" "),
      _c(_setup.ClubSwitchFilters),
      _vm._v(" "),
      _c(_setup.HighRatingFilters),
      _vm._v(" "),
      _c(_setup.AppointmentFilters),
      _vm._v(" "),
      _c(_setup.LpuFilters),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }